/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";
import SoftButton from "components/SoftButton";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
  minWidth: 100,
};

const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: uuidV4(),
    value6: "",
    value7: "",
    value8: "",
    value9a: "",
    value9: "",
    value10: "",
    value11: "",
    value12: "",
  },
];

export default function TaxPersonalTable04({ formData, setFieldValue, count }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleAdd = () => {
    const newRow = {
      id: uuidV4(),
      value6: "",
      value7: "",
      value8: "",
      value9a: "",
      value9: "",
      value10: "",
      value11: "",
      value12: "",
    };
    setData((prev) => [...prev, newRow]);
  };

  const handleDelete = (id) => setData((prev) => prev.filter((item) => item.id !== id));

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (id === item.id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td className="toggle-button" rowSpan={1} style={{ textAlign: "center", width: 10 }}>
                STT
                <div className="button-action">
                  <button type="button" onClick={handleAdd}>
                    Thêm dòng
                  </button>
                </div>
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Họ và tên hộ kinh doanh, cá nhân kinh doanh
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Mã số thuế hộ kinh doanh, cá nhân
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Nhóm ngành nghề
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Doanh thu
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Số thuế GTGT
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Số thuế TNCN
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Tổng số thuế GTGT, TNCN
              </Td>
            </tr>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (06)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (07)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (08)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (09a)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (09)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (10)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (11)
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                (12)=(10)+(11)
              </Td>
            </tr>
            {data.map((item, index) => (
              <tr key={item.id}>
                <Td className="toggle-button" rowSpan={1} style={{ textAlign: "center" }}>
                  {index + 1}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete(item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td rowSpan={1} style={{ textAlign: "left", maxWidth: 100, fontStyle: "italic" }}>
                  <InputTable
                    type="text"
                    id={item.id}
                    name="value7"
                    value={item.value7}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "center" }}>
                  <InputTable
                    type="text"
                    id={item.id}
                    name="value8"
                    value={item.value8}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "right" }}>
                  <InputTable
                    type="text"
                    id={item.id}
                    name="value9a"
                    value={item.value9a}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "right" }}>
                  <InputTable
                    id={item.id}
                    name="value9"
                    value={item.value9}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "right" }}>
                  <InputTable
                    id={item.id}
                    name="value10"
                    value={item.value10}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "right" }}>
                  <InputTable
                    id={item.id}
                    name="value11"
                    value={item.value11}
                    onChange={handleChange}
                  />
                </Td>
                <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}>
                  0
                </Td>
              </tr>
            ))}
            <tr>
              <Td
                rowSpan={1}
                colSpan={4}
                style={{ textAlign: "center", background: "#ddeff3", fontWeight: 700 }}
              >
                Tổng cộng
              </Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}>
                0
              </Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}>
                0
              </Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}>
                0
              </Td>
              <Td rowSpan={1} style={{ textAlign: "right", background: "#ddeff3" }}>
                0
              </Td>
            </tr>
          </tbody>
        </table>
        <SoftButton style={{ marginTop: 10 }} variant="gradient" color="dark" onClick={handleAdd}>
          Thêm dòng
        </SoftButton>
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { onChange, id, type, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    if (!type) {
      const newValue = value === "0" ? "" : value;
      if (!regexNumber.test(newValue)) return;
      onChange({ value: newValue !== "" ? +newValue : "", name, id });
    } else {
      onChange({ value, name, id });
    }
  }
  return (
    <input
      type="text"
      style={{
        textAlign: !type ? "right" : "left",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
        outline: "none",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
